import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IRolePermission;

const rolePermissionSlice = createSlice({
    name: "rolePermission",
    initialState,
    reducers: {
        setRole: (state, action: PayloadAction<IUserRole | undefined>) => {
            if (action.payload) {
                (state.role = action.payload.role), (state.role_id = action.payload.role_id);
                state.description = action.payload.description;
            }
        },
        setRolePermission: (state, action: PayloadAction<IPermission[] | undefined>) => {
            if (action.payload) {
                state.permissions = action.payload;
            }
        },
    },
});

export const { setRole, setRolePermission } = rolePermissionSlice.actions;
export default rolePermissionSlice.reducer;

export const getRolePermission = (state: RootState) => state.rolePermission;
